module.exports = __webpack_public_path__ + "pt.d96ca6926c99489a652f.jpg";